import React from 'react';
import CmdbHardware from './CmdbHardware';
import './CmdbModal.css';

// Modal que abriga o CMDB do hardware (Fase 9A) — dá espaço fora da gaveta estreita.
function CmdbModal({ open, onClose, codhar, patrimonio, descricao }) {
  if (!open) return null;
  return (
    <div className="cmdb-modal-overlay" onClick={onClose}>
      <div className="cmdb-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cmdb-modal-head">
          <h4 className="cmdb-modal-titulo"><i className="fas fa-sitemap me-2" />CMDB do ativo</h4>
          <button type="button" className="cmdb-modal-close" onClick={onClose} aria-label="Fechar"><i className="fas fa-times" /></button>
        </div>
        <div className="cmdb-modal-body">
          <CmdbHardware codhar={codhar} patrimonio={patrimonio} descricao={descricao} semCard />
        </div>
      </div>
    </div>
  );
}

export default CmdbModal;
